import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../common/Button';
import './AuditLogs.css';

const AuditLogs = () => {
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterAction, setFilterAction] = useState('all');
  const [filterUser, setFilterUser] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    setTimeout(() => {
      const mockLogs = [];
      for (let i = 1; i <= 45; i++) {
        mockLogs.push({
          id: i,
          timestamp: `2024-03-${Math.floor(Math.random() * 15) + 10} ${Math.floor(Math.random() * 24)}:${Math.floor(Math.random() * 60)}:${Math.floor(Math.random() * 60)}`,
          user: ['admin@marilink.com', 'owner@orientshipping.com', 'vendor@marinetech.com'][Math.floor(Math.random() * 3)],
          userName: ['Sarah Johnson', 'John Smith', 'Ahmed Hassan'][Math.floor(Math.random() * 3)],
          userRole: ['admin', 'owner', 'vendor'][Math.floor(Math.random() * 3)],
          action: ['create', 'update', 'delete', 'login'][Math.floor(Math.random() * 4)],
          resource: ['RFQ', 'User', 'Vessel', 'Payment', 'Dispute'][Math.floor(Math.random() * 5)],
          resourceId: `RES-${Math.floor(Math.random() * 1000)}`,
          details: `User performed ${['create', 'update', 'delete', 'login'][Math.floor(Math.random() * 4)]} action on ${['RFQ', 'User', 'Vessel', 'Payment', 'Dispute'][Math.floor(Math.random() * 5)]}`,
          ipAddress: `192.168.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}`,
          userAgent: 'Mozilla/5.0...'
        });
      }
      setLogs(mockLogs.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)));
      setLoading(false);
    }, 800);
  }, []);

  const filteredLogs = logs.filter(log => {
    const matchesAction = filterAction === 'all' || log.action === filterAction;
    const matchesUser = filterUser === 'all' || log.userRole === filterUser;
    const matchesSearch = log.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          log.resource.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          log.details.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesAction && matchesUser && matchesSearch;
  });

  const totalPages = Math.ceil(filteredLogs.length / itemsPerPage);
  const paginatedLogs = filteredLogs.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const getActionColor = (action) => {
    switch(action) {
      case 'create': return 'create';
      case 'update': return 'update';
      case 'delete': return 'delete';
      case 'login': return 'login';
      default: return 'update';
    }
  };

  const handleExport = () => {
    alert('Exporting audit logs to CSV...');
  };

  if (loading) return <div className="loading-spinner">Loading audit logs...</div>;

  return (
    <div className="audit-logs-page">
      <div className="page-header">
        <h1><i className="fas fa-history"></i> Audit Logs</h1>
        <p>Track all system activities and user actions</p>
      </div>

      <div className="filters-bar">
        <div className="filter-group">
          <select className="filter-select" value={filterAction} onChange={(e) => setFilterAction(e.target.value)}>
            <option value="all">All Actions</option>
            <option value="create">Create</option>
            <option value="update">Update</option>
            <option value="delete">Delete</option>
            <option value="login">Login</option>
          </select>
          <select className="filter-select" value={filterUser} onChange={(e) => setFilterUser(e.target.value)}>
            <option value="all">All Users</option>
            <option value="admin">Admin</option>
            <option value="owner">Ship Owner</option>
            <option value="vendor">Service Provider</option>
          </select>
        </div>
        <div className="search-box">
          <i className="fas fa-search"></i>
          <input type="text" placeholder="Search logs..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        </div>
        <Button variant="outline" icon="fa-download" onClick={handleExport} className="export-btn">
          Export CSV
        </Button>
      </div>

      <div className="logs-table-container">
        <table className="logs-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>User</th>
              <th>Role</th>
              <th>Action</th>
              <th>Resource</th>
              <th>Resource ID</th>
              <th>Details</th>
              <th>IP Address</th>
            </tr>
          </thead>
          <tbody>
            {paginatedLogs.map(log => (
              <tr key={log.id}>
                <td>{log.timestamp}</td>
                <td>{log.userName}</td>
                <td>{log.userRole}</td>
                <td><span className={`action-type ${getActionColor(log.action)}`}>{log.action.toUpperCase()}</span></td>
                <td>{log.resource}</td>
                <td>{log.resourceId}</td>
                <td>{log.details}</td>
                <td>{log.ipAddress}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button className="page-btn" onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
            <i className="fas fa-angle-double-left"></i>
          </button>
          <button className="page-btn" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>
            <i className="fas fa-angle-left"></i>
          </button>
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            let pageNum;
            if (totalPages <= 5) {
              pageNum = i + 1;
            } else if (currentPage <= 3) {
              pageNum = i + 1;
            } else if (currentPage >= totalPages - 2) {
              pageNum = totalPages - 4 + i;
            } else {
              pageNum = currentPage - 2 + i;
            }
            return (
              <button key={pageNum} className={`page-btn ${currentPage === pageNum ? 'active' : ''}`} onClick={() => setCurrentPage(pageNum)}>
                {pageNum}
              </button>
            );
          })}
          <button className="page-btn" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>
            <i className="fas fa-angle-right"></i>
          </button>
          <button className="page-btn" onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>
            <i className="fas fa-angle-double-right"></i>
          </button>
        </div>
      )}
    </div>
  );
};


export default AuditLogs;